import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=29df070c&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=29df070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29df070c",
  null
  
)

export default component.exports